"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padMilitaryTime = exports.parseMilitaryTime = exports.validateMilitaryTime = void 0;
const validateMilitaryTime = (value) => {
    if (!/^\d{4}$/.test(value)) {
        return 'Please enter four-digit military time.';
    }
    if (Number(value) > 2359) {
        return 'Time cannot be greater than 2359';
    }
    if (Number(value.slice(2)) > 59) {
        return 'Minutes must be less than 60';
    }
    return undefined;
};
exports.validateMilitaryTime = validateMilitaryTime;
const parseMilitaryTime = (value) => {
    if ((0, exports.validateMilitaryTime)(value)) {
        return undefined;
    }
    return {
        hour: Number(value.slice(0, 2)),
        minute: Number(value.slice(2)),
    };
};
exports.parseMilitaryTime = parseMilitaryTime;
// Pads only a non-zero lead: "930" is unambiguously 0930.
const padMilitaryTime = (value) => {
    let digits = value.replace(/\D/g, '');
    if (digits.length === 3 && Number(digits[0]) > 0) {
        digits = digits.padStart(4, '0');
    }
    return digits;
};
exports.padMilitaryTime = padMilitaryTime;
//# sourceMappingURL=military-time.js.map